// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9774) return "static/chunks/framework-8f2750b78e5a89e7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"593":"a7bce429730ed526","4395":"f4b807778ec9f615","9389":"bbc2463ec7387dc0"}[chunkId] + ".js";
};